import { Component, ComponentRef, Type, ViewChild, ViewContainerRef, effect, signal, Input, inject, ChangeDetectionStrategy } from '@angular/core';

import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { GenericListComponent } from '@app/common-codes/components/list-components/generic-base-list/generic-list.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { TabComponentLoader } from '@app/common-codes/services/TabComponentLoader.service';
import { ListTableColumnComponent } from '@app/common-codes/components/list-components/list-table-column/list-table-column.component';
import { ListViewComponent } from '@app/common-codes/components/list-components/list-view/list-view.component';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Account as TenantAccount } from '@app/common-codes/models/matwins-tenant/Account.model';
import { Account as ManagerAccount } from '@app/common-codes/models/matwins-manager/Account.model';
import { TenantAccountDetailComponent } from '../account-detail/account-detail.component';
import { LookupItem, LookupProfile, LookupService } from '@app/common-codes/services/LookupService';
import { Account_POS } from '@app/common-codes/models/matwins-tenant/navigation-entities/Account_POS.model';
import { Client } from '@app/common-codes/models/matwins-manager/Client.model';
import { PointOfService } from '@app/common-codes/models/matwins-tenant/PointOfService.model';
import { AccountPermissionsDetailComponent } from '../account-detail/permissions-detail.component';
import { ReactiveBadgeComponent } from '@app/common-codes/components/nested-components/reactive-badge/reactive-badge.component';
import { AccountBase } from '@app/common-codes/models/AccountBase.model';
import { AccountBaseDetailComponent } from '@app/components/account/accountBase-detail.component';

@Component({
  template: '', // fourni par les enfants
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export abstract class AccountBaseListComponent<T extends AccountBase> extends GenericListComponent<T> {

  override Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  // override ComponentEntityClass = Account;
  // override entityMetaData: IEntityMetaData = {
  //   ...new Account().GetType(),
  //   EndPoint: "/tenantAccounts"
  // };
  private loadedComponents: { [key: string]: ComponentRef<any> } = {};
  override contextMenuItems = [];
  // isModalOpen = signal(false);
  isPermissionModalOpen = signal(false);
  modalEntity = signal<AccountBase | null>(null);
  @ViewChild('accountDetail', { read: AccountBaseDetailComponent<T> }) accountBaseDetail!: AccountBaseDetailComponent<T>;
  editPermissionsLookupArray: LookupItem[] = [{ id: '1', key: '1', value: 'Permissions', visible: true, additionalData: { displaystate: 'badge rounded info', } }];



  constructor(_alertModalService: AlertModalService) {
    super();
    this.alertModalService = _alertModalService;
  }

  onSearchInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchTerm.set(value);
    this.listView()?.onSearch(value);
  }

  override async ngOnInit() {
    super.ngOnInit();
    // Mettre à jour les métadonnées du repository pour utiliser le bon EndPoint
    const repository = (this.dataService as any).repository;
    if (repository && repository.setMetaData) {
      repository.setMetaData(this.entityMetaData);
    }
    // TODO : enlever ceci pour ne pas generer de requete au chargement du client
    // pour le moment je le laisse parce que si je ne le fais pas, la liste ne se charge pas
    //const params: StructuredDataRequest = {
    //  pageNumber: 1,
    //  pageSize: this.listView()?.pageSize() ?? 5,
    //  search: this.searchTerm(),
    //  sortBy: this.listView()?.sortBy(),
    //  sortOrder: this.listView()?.sortOrder(),
    //  combinedSearchColumns: undefined,
    //  requiredLookups: undefined
    //};
    //  await this.performLoadData(params, 0, params.pageSize);   // ### performLoadData
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }



  override editSelectedItem(selectedItem: T) {
    this.getdetailComponent()?.componentInstancesService?.closeAllComponents();
    this.selectedItem.set(selectedItem);
    this.isPermissionModalOpen.set(false);
    this.isModalOpen.set(true);
  }

  editPermissions(selectedItem: T) {
    this.getdetailComponent()?.componentInstancesService?.closeAllComponents();
    this.selectedItem.set(selectedItem);
    this.isModalOpen.set(false);
    this.isPermissionModalOpen.set(true);
  }


  // closeModal() {
  //   this.isModalOpen.set(false);
  //   this.selectedItem.set(null);
  //   // this.refreshList();
  // }

  closePermissionModal() {
    this.isPermissionModalOpen.set(false);
    this.selectedItem.set(null);
    // this.refreshList();
  }


  doSpecialAction(entity: T, action: string, item: any) {
    if (action === 'editPermissions')
      this.editPermissions(entity);
  }
}

@Register(TenantAccount)
@Component({
  selector: 'app-tenant-account-list',
  templateUrl: './account-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ListViewComponent,
    TenantAccountDetailComponent,
    ListTableColumnComponent,
    TranslatePipe,
    AccountPermissionsDetailComponent,
    ReactiveBadgeComponent
  ]
})
export class TenantAccountListComponent extends AccountBaseListComponent<TenantAccount> {

  override ComponentEntityClass = TenantAccount;
  override entityMetaData: IEntityMetaData = new TenantAccount().GetType();
  @ViewChild('accountDetail', { read: TenantAccountDetailComponent }) accountDetail!: TenantAccountDetailComponent;

  public static override get lookupProfiles(): LookupProfile[] {
    const lookupProfiles: LookupProfile[] = [
      {
        lookupName: "Role",
        lookupNamespace: "Matwins.Core.Model.MatwinsTenant"
      },
      {
        lookupName: "i18nLanguage"
      },
      {
        lookupName: "PointOfService",
      }
    ];
    return lookupProfiles;
  }

  posLookup = signal<LookupItem[]>([]);


  constructor(_alertModalService: AlertModalService) {
    super(_alertModalService);
    effect(() => {
      // Lire la revision : si les listes arrivent en retard, l'effet repasse et les remplit.
      this.lookupService.revision();
      const posData = this.lookupService.getLookupData('PointOfService');
      posData.forEach(item => {
        if (!item.additionalData) item.additionalData = {};
        if (!item.additionalData['containerdisplaystate']) {
          item.additionalData['containerdisplaystate'] = 'containerBadge rounded info';
        }
        if (!item.additionalData['displaystate']) {
          item.additionalData['displaystate'] = 'badge';
        }
      });
      this.posLookup.set(posData);
    }
    )
  }

  getRoleTitle(entity: TenantAccount): string {
    const item = this.lookupService.getLookupData('Role', 'Matwins.Core.Model.MatwinsTenant')
      .find(r => parseInt(r.key) === entity.fK_Role);
    return item?.value?.trim() ?? '';
  }

  getPosBadgeLookup(accountPos: Account_POS): LookupItem[] {
    const baseLookup = this.lookupService.getLookupData('PointOfService');
    const posItem = baseLookup.find(p => parseInt(p.key) === accountPos.fK_POS);
    if (!posItem)
      return [];

    const isResponsible = accountPos.isTruckerResponsible;
    return [{
      ...posItem,
      additionalData: {
        ...posItem.additionalData,
        containerdisplaystate: isResponsible ? 'containerBadge rounded warning' : 'containerBadge rounded success',
        displaystate: 'badge',
        truckerresponsibleicon: isResponsible ? (posItem.additionalData?.['truckerresponsibleicon'] ?? '') : ''
      }
    }];
  }

  override getdetailComponent(): GenetricDetailComponent<TenantAccount> | undefined {
    return this.accountDetail;
  }

  override postAddedItem(updatedItem: TenantAccount) {
    const clientId = this.mediator?.selectedRootId(); // Signal<number | string | null>
    const client = this.mediator?.selectedRoot() as Client;

    const poss: PointOfService[] = client?.relatedTenant?.pointOfServices ?? [];
    poss.forEach(pos => {
      if (updatedItem.accountPOS?.some(a => a.fK_POS === pos.id))
        pos.accounts?.push(updatedItem);
    });

  }

  override onItemUpdated(updatedItem: AccountBase) {
    super.onItemUpdated(updatedItem as TenantAccount);
  }

}
